import React from 'react';
import './WorkflowProgress.css';

function WorkflowProgress({ workflowSteps }) {
  if (!workflowSteps || workflowSteps.length === 0) {
    return <span className="workflow-progress-text">No workflow</span>;
  }

  const required = workflowSteps.filter((s) => s.required);
  const completed = required.filter((s) => s.completed);
  const percentage = Math.round((completed.length / required.length) * 100);

  let progressClass = 'progress-low';
  if (percentage >= 66) {
    progressClass = 'progress-high';
  } else if (percentage >= 33) {
    progressClass = 'progress-medium';
  }

  return (
    <div className="workflow-progress">
      <div className="progress-text">
        {completed.length}/{required.length}
      </div>
      <div className="progress-bar-container">
        <div
          className={`progress-bar ${progressClass}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}

export default WorkflowProgress;
